import { ReactNode, RefObject } from 'react';
import { CTA_SUBNAV_CLASSNAME } from '../shared/constants';
import styles from './desktop_header.module.scss';

export interface DesktopHeaderProps {
  titleChild: ReactNode;
  navLinks: ReactNode[];
  primaryButton: ReactNode;
  secondaryButton: ReactNode;
  headerRef: RefObject<HTMLDivElement>;
}

/**
 * Desktop header layout component
 * Displays title on the left, nav links and actions on the right
 * Becomes sticky when scrolling
 */
const DesktopHeader = ({
  titleChild,
  navLinks,
  primaryButton,
  secondaryButton,
  headerRef,
}: DesktopHeaderProps) => {
  return (
    <div
      ref={headerRef}
      className={`${styles.desktopHeader} ${CTA_SUBNAV_CLASSNAME}`}
      data-testid="cta-subnav-desktop-header"
    >
      <div className={styles.titleContainer}>{titleChild}</div>
      <div className={styles.ctaContainer}>
        {navLinks.map((link, index) => (
          <div key={index} className={styles.navItem}>
            {link}
          </div>
        ))}
        {secondaryButton}
        {primaryButton}
      </div>
    </div>
  );
};

export default DesktopHeader;
